module.exports = __webpack_public_path__ + "static/img/web2.b2878c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web2.png
// module id = Kgtz
// module chunks = 0